import { GridDashboardItem, InsightDashboardItemType } from '../../types/insight-custom-dashboard';
import { getSDGTitle } from '@constants/sdg-data';
import { getExtendedGoalCode } from '@utils/sdg';
import { getSrc } from '@g17eco/molecules/sdg-icon/utils';
import { IntegrationData } from '@g17eco/types/app-integration';

export const PADDING = 3;

interface GetIntegrationTitleParams {
  item: GridDashboardItem;
  integrationsData?: IntegrationData;
}

export const getIntegrationTitle = ({ item, integrationsData }: GetIntegrationTitleParams): string => {
  if (!('variables' in item) || !item.variables) {
    return '';
  }

  const [firstMetric] = Object.values(item.variables);
  if (!firstMetric || !integrationsData?.utrsData.length) {
    return '';
  }

  const utr = integrationsData.utrsData?.find(({ utr }) => utr.code === firstMetric.code)?.utr;
  if (!utr) {
    return '';
  }

  if (firstMetric.valueListCode && utr.valueType === 'table') {
    const column = utr.valueValidation?.table?.columns?.find(({ code }) => code === firstMetric.valueListCode);
    return column?.name ?? utr.name;
  }
  return utr.name;
};

interface GetTitleParams {
  item: GridDashboardItem;
  integrationsData?: IntegrationData;
}

export const getTitle = ({ item, integrationsData }: GetTitleParams): string | undefined => {
  if ('title' in item && item.title) {
    return item.title;
  }

  if (item.type === InsightDashboardItemType.Integration) {
    return getIntegrationTitle({ item, integrationsData });
  }

  if (item.type === InsightDashboardItemType.SDGTracker && item.variables) {
    const firstMetric = Object.values(item.variables)[0];
    if (firstMetric) {
      return getSDGTitle({ goalCode: getExtendedGoalCode(firstMetric.code) ?? '' });
    }
  }

  return undefined;
};

export const getItemIcon = (item: GridDashboardItem): string | undefined => {
  if ('icon' in item && item.icon) {
    return item.icon;
  }

  if (
    item.type === InsightDashboardItemType.SDGTracker &&
    item.variables &&
    Object.values(item.variables).length === 1
  ) {
    const firstMetric = Object.values(item.variables)[0];
    const code = getExtendedGoalCode(firstMetric.code);
    return code ? getSrc({ code }) : undefined;
  }

  return undefined;
};

export const getDisableTooltip = (action: string): string => `Preloaded widgets can not be ${action}.`;
